<div class="flex">
  <span class="paymentLogoText" dsContent [contentPath]="'billing.phoenixPayment.weAccept'"></span>
  <span class="logoSpace"
    ><img src="/assets/images/visa.svg" alt="visa image" data-cy="visaImage"
  /></span>
  <span class="master logoSpace"
    ><img
      src="/assets/images/logo_mastercard.svg"
      alt="master image"
      data-cy="masterImage"
      class="logoMaster"
  /></span>
  @if (isHomesite) {
    <span class="logoSpace"
      ><img src="/assets/images/discover.svg" alt="discover image" data-cy="discoverImage"
    /></span>
  }
  <span class="logoSpace"
    ><img src="/assets/images/amex.svg" alt="amex image" data-cy="amexImage"
  /></span>
</div>
